import React from "react";
import ReactDOM from "react-dom";
import axios from 'axios'
class Calendar extends React.Component {
  readonly calendarDisplayNum = 14;
  props = {
    json_name: null,
  };
  state = {
    startDate: null,
    endDate: null,
    maxDate: null,
    minDate: null,
    calendarEvents: null,
    currentMonth: null,
    currentDisplayUnit: 3,
    currentDisplayUnitMin: 1,
    currentDisplayUnitMax: 5,
  };



  private getDateString(date: Date) {
    var y = date.getFullYear();
    var m = ("00" + (date.getMonth() + 1)).slice(-2);
    var d = ("00" + date.getDate()).slice(-2);
    var result = y + "-" + m + "-" + d;
    return result;
  }



  componentDidMount() {
    // axios.get(`/api_cache/calendar/higasiyukigaya.json`)
    axios.get(`/api_cache/calendar/${this.props.json_name}.json`)
      .then(res => {
        const calendarData = res.data;
        console.log('calendarData');
        console.log(calendarData);
        console.log(calendarData.content);
        this.setState({ endDate: calendarData.header.end_date });
        this.setState({ maxDate: calendarData.header.max_date });
        this.setState({ minDate: calendarData.header.min_date });
        this.setState({ startDate: calendarData.header.start_date });

        let splitDate = this.state.minDate.split('-');
        var dateMin = new Date(splitDate[0], (splitDate[1] - 1), splitDate[2]);
        console.log('dateMin');
        console.log(dateMin.getFullYear());
        console.log(dateMin.getMonth() + 1);
        console.log(dateMin.getDate());

        splitDate = this.state.maxDate.split('-');
        var dateMax = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
        console.log('dateMax');
        console.log(dateMax.getFullYear());
        console.log(dateMax.getMonth() + 1);
        console.log(dateMax.getDate());

        var termDay = (dateMax.getTime() - dateMin.getTime()) / 86400000 + 1;
        console.log('termDay');
        console.log(termDay);
        let dateCounter = new Date(dateMin);
        let calendarEvents = [];
        let dateCount = 1;
        let calendarDisplayUnit = 1;
        let today = this.getDateString(new Date());

        for (let index = 0; index < termDay; index++) {

          let currentDate = this.getDateString(dateCounter);
          let eventItems = []
          if (currentDate in calendarData.content) {
            let item = calendarData.content[currentDate];
            console.log(item);
            item.forEach(eventItem => {
              // console.log(eventItem);
              eventItems.push(eventItem)
            })
          }

          let isToday = today == currentDate;
          if (isToday) {
            console.log('currentDate')
            console.log(currentDate);
            let splitDate = currentDate.split('-');

            this.setState({ currentMonth: (Number(splitDate[1])) })
            this.setState({ currentYear: (Number(splitDate[0])) })
          }

          calendarEvents.push({
            date: currentDate,
            day: dateCounter.getDate(),
            month: dateCounter.getMonth() + 1,
            year: dateCounter.getFullYear(),
            eventItems: eventItems,
            isToday: isToday,
            isModalOpen: false,
            // dateCount: dateCount,
            calendarDisplayUnit: calendarDisplayUnit,
          })
          dateCount++
          if (dateCount > this.calendarDisplayNum) {
            dateCount = 1;
            this.setState({ currentDisplayUnitMax: calendarDisplayUnit })
            calendarDisplayUnit++;
          }
          dateCounter.setDate(dateCounter.getDate() + 1)

        }
        console.log('dateCounter');
        console.log(dateCounter.getFullYear());
        console.log(dateCounter.getMonth() + 1);
        console.log(dateCounter.getDate());

        console.log(calendarEvents);
        this.setState({ calendarEvents: calendarEvents });
      })
  }

  modalOpen(e: React.MouseEvent) {
    console.log('modalOpen')
    console.log(this.state.currentDisplayUnitMax)
    console.log(e.currentTarget.attributes);
    console.log(e.currentTarget.attributes.getNamedItem('data-date').value);
    const targetDate = e.currentTarget.attributes.getNamedItem('data-date').value;
    // this.setState({currentDisplayUnit:4})
    console.log(this.state.calendarEvents);

    for (let index = 0; index < this.state.calendarEvents.length; index++) {
      const item = this.state.calendarEvents[index];
      console.log(item.date);
      if (targetDate == item.date) {
        this.state.calendarEvents[index].isModalOpen = !this.state.calendarEvents[index].isModalOpen;
      } else {
        this.state.calendarEvents[index].isModalOpen = false;
      }

    }
    this.setState({ calendarEvents: this.state.calendarEvents });
  }

  toPrev(e: React.MouseEvent) {
    console.log('toPrev')
    console.log(this.state.currentDisplayUnitMin)
    if (this.state.currentDisplayUnit > this.state.currentDisplayUnitMin) {
      this.setState({ currentDisplayUnit: this.state.currentDisplayUnit - 1 })
    }

  }
  toNext(e: React.MouseEvent) {
    console.log('toNext')
    console.log(this.state.currentDisplayUnitMax)
    if (this.state.currentDisplayUnit < this.state.currentDisplayUnitMax) {
      this.setState({ currentDisplayUnit: this.state.currentDisplayUnit + 1 })
    }
  }
  render() {
    let currentEventsList = []
    let currentMonth = null;
    let currentYear = null;
    const modalThreshold = 4; // 公開時には4にする
    const dayOfWeekStrJP = ["日", "月", "火", "水", "木", "金", "土"];

    if (this.state.calendarEvents) {
      // let currentEvents = this.state.currentCalendarEvents;
      let currentEvents = this.state.calendarEvents.filter(eventItem => eventItem.calendarDisplayUnit == this.state.currentDisplayUnit);
      console.log(currentEvents);

      let monthCount = [];
      let yearCount = [];
      for (let i in currentEvents) {
        if (currentEvents[i].month) {
          monthCount[currentEvents[i].month] = monthCount[currentEvents[i].month] ? monthCount[currentEvents[i].month] + 1 : 1;
          yearCount[currentEvents[i].year] = yearCount[currentEvents[i].year] ? yearCount[currentEvents[i].year] + 1 : 1;
        }
      }
      console.log(yearCount);


      let monthCountKeys = Object.keys(monthCount);
      let monthCountKeysLength = monthCountKeys.length;
      if (monthCountKeysLength == 1) {
        currentMonth = Number(monthCountKeys[0])
      }
      else {
        let maxCount = 0;
        monthCountKeys.forEach(function (key) {
          if (maxCount < monthCount[key]) {
            maxCount = monthCount[key];
            currentMonth = Number(key);
          }
        });
      }
      console.log(currentMonth);


      let yearCountKeys = Object.keys(yearCount);
      let yearCountKeysLength = yearCountKeys.length;
      if (yearCountKeysLength == 1) {
        currentYear = Number(yearCountKeys[0])
      }
      else {
        let maxCount = 0;
        yearCountKeys.forEach(function (key) {
          if (maxCount < yearCount[key]) {
            maxCount = yearCount[key];
            currentYear = Number(key);
          }
        });
      }
      console.log(currentYear);


      for (let i in currentEvents) {
        let dateClass = 'date' + (currentEvents[i].isToday ? ' is_today' : '');
        let currentDate = currentEvents[i].date;
        console.log(currentDate);

        let eventItemList = [];
        let eventItemListAll = [];
        let isModalOpen = currentEvents[i].isModalOpen;

        let splitDate = currentDate.split('-');
        var currentDateObj = new Date(splitDate[0], (splitDate[1] - 1), splitDate[2]);
        let currentWeek = dayOfWeekStrJP[currentDateObj.getDay()];
        console.log(dayOfWeekStrJP[currentDateObj.getDay()] + '曜日');
        let isSeeMore = false;
        let itemIndex = 0;

        for (let j = 0; j < currentEvents[i].eventItems.length; j++) {

          let currentEventItem = currentEvents[i].eventItems[j];
          console.log(currentEventItem);
          const style = {
            backgroundColor: currentEventItem.colorDisplay
          }
          let currentId = currentDate + j;
          // もっと見るのモーダル
          if (j < modalThreshold) {
            eventItemList.push(<div key={'event_item_list_' + currentId} className="event-item" style={style} data-colorid={currentEventItem.colorId}><div className="event-text">{currentEventItem.title}</div></div>)
          } else {
            isSeeMore = true;
          }
          itemIndex++;
          // modal用
          eventItemListAll.push(<div key={'event_item_list_all_' + currentId} className="event-item" style={style} data-colorid={currentEventItem.colorId}><div className="event-text">{currentEventItem.title}</div></div>)
        }
        let diff = itemIndex - modalThreshold;
        let seeMoreContent = isSeeMore ? <div className="calendar-show-more">他{diff}件</div> : ''
        let modalContent =
          <div className="calendar-modal-area">
            <div className="calendar-modal-wrap">
              <div className="calendar-modal">
                <div className="calendar-modal-header">
                  <div className="calendar-modal-header-week">{currentWeek}</div>
                  <div className="calendar-modal-header-day">{currentEvents[i].day}</div>
                </div>
                <div className="calendar-modal-content">
                  {eventItemListAll}
                </div>
              </div>
            </div>
          </div>
        currentEventsList.push(<li key={'date_list_calendar_item_' + currentDate} className={'calendar-item ' + (isModalOpen ? 'is_modal_open' : '')} data-date={currentDate} onClick={(e) => this.modalOpen(e)}><div className="date-area" ><span className={dateClass} >{currentEvents[i].day}</span></div>{eventItemList}{seeMoreContent}{modalContent}

        </li>);
      }
    }

    return (
      <div className="calendar-root">
        <div className="calendar-header">
          <div className="button-prev-wrap">
            {this.state.currentDisplayUnit != this.state.currentDisplayUnitMin && <div className="button-prev" onClick={(e) => this.toPrev(e)}>前の週</div>}

          </div>
          <div className="calendar-year-month"><div className="year">{currentYear}年</div><div className="month"><span className="text-main">{currentMonth}</span>月</div></div>
          <div className="button-next-wrap">
            {this.state.currentDisplayUnit != this.state.currentDisplayUnitMax && <div className="button-next" onClick={(e) => this.toNext(e)}>次の週</div>}

          </div>

        </div>
        <ul className="calendar-weeks">
          <li className="week-item">月</li>
          <li className="week-item">火</li>
          <li className="week-item">水</li>
          <li className="week-item">木</li>
          <li className="week-item">金</li>
          <li className="week-item">土</li>
          <li className="week-item">日</li>
        </ul>
        <ul className="calendar-content">
          {currentEventsList}
        </ul>

      </div>
    );
  }
}

document.querySelectorAll<HTMLInputElement>('#app_calendar_area .app-calendar').forEach((el) => {
  let data_json_name = el.dataset.calendarName;
  console.log(data_json_name);
  ReactDOM.render(<Calendar json_name={data_json_name} />, el);
})
